import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  services: any;

  constructor(
    private router: Router,
  ) {
    this.services = {
      async handleSignIn(formData: Record<string, any>) {
        await Auth.signIn(formData['username'], formData['password'])
        router.navigate(['/dashboard'])
      }
    }
  }

}